<template>
	<div>
		<Header :isHome="false"></Header>
		<div class="top-bg" style="padding-top: 7rem;">

		</div>
		<div class="container">
			<div style="font-size: 1rem;font-weight: 500;color: #999;margin-bottom: 1rem;">
				<span class="hover-light" style="cursor: pointer;margin-right: 0.5rem;" @click="tohome()">Home</span>>
				<span class="hover-light" style="margin: 0 0.5rem;cursor: pointer;"
					@click="$router.push({name:'customizeList'})">Customized Demands</span>>
				<span style="margin-left: 0.5rem;color: #000;">Quotation Details</span>
			</div>
			<div class="df fdc bg-white wow fadeInUp animated" style="padding: 2rem;border: 1px solid #e8e8e8;">
				<div class="df aic" style="margin-bottom: 1.5rem;">
					<img :src="data.user?data.user.avatar:''" width="50" height="50" style="border-radius: 50%;"
						alt="" />
					<div class="title" style="font-size: 1.3rem;margin-left: 1rem;">{{data.user?data.user.username:''}}
					</div>
				</div>
				<div class="title df aic">{{data.title}}</div>
				<div class="df aic" style="margin-top: 1.5rem;font-size: 18px;font-weight: bold;">
					<div>Quotation:</div>
					<span style="color: #FF2C2C;margin-left: 0.5rem;">${{data.budget_price}}</span>
				</div>
				<div class="describe" ref="describe" :class="{'text_over_2line':hideDetail}">{{data.sub_title}}</div>
				<div v-if="hideDetail" style="text-decoration: underline;color: #22F7D3;cursor: pointer;"
					@click="hideDetail=false" class="df">more></div>
				<div class="title df aic" style="margin-top: 3rem;">
					Product attributes
				</div>
				<div class="attr df fww" :style="`${isMobile?'width: 100%;':'width: 50%;'}`">
					<div class="df" :style="`${isMobile?'width: 100%;':'width: 50%;'}`" style="margin-top: 0.5rem;"
						v-if="data.category">
						<div class="key" style="font-weight: bold;margin-right: 0.6rem;">Type:</div>
						<div class="value">{{data.category.name}}</div>
					</div>
					<div class="df" :style="`${isMobile?'width: 100%;':'width: 50%;'}`" style="margin-top: 0.5rem;">
						<div class="key" style="font-weight: bold;margin-right: 0.6rem;">Brand:</div>
						<div class="value">{{data.brand}}</div>
					</div>
					<div class="df" :style="`${isMobile?'width: 100%;':'width: 50%;'}`" style="margin-top: 0.5rem;"
						v-if="data.country">
						<div class="key" style="font-weight: bold;margin-right: 0.6rem;">country:</div>
						<div class="value">{{data.country.englishName}}</div>
					</div>
					<div class="df" :style="`${isMobile?'width: 100%;':'width: 50%;'}`" style="margin-top: 0.5rem;"
						v-if="data.Certification">
						<div class="key" style="font-weight: bold;margin-right: 0.6rem;">Certification:</div>
						<div class="value">{{data.authentications}}</div>
					</div>
					<div class="df" :style="`${isMobile?'width: 100%;':'width: 50%;'}`"
						v-for="(item,key) in data.properties" style="margin-top: 0.5rem;">
						<div class="key" style="font-weight: bold;margin-right: 0.6rem;">{{key}}:</div>
						<div class="value">{{item}}</div>
					</div>
				</div>
				<div style="width: 100%;margin-top: 2rem;" v-html="data.description"></div>
				<div class="df jcc" v-if="data.attachment">
					<el-button @click="download" style="width: 13rem;font-weight: bold;"
						icon="el-icon-download">Download file</el-button>
				</div>
			</div>
			<template v-if="user.uid==data.uid">
				<div :style="`${isMobile?'margin: 1rem 0;':'margin: 2rem 0;'}`" class="title">Quotation record</div>
				<div class="bg-white df fdc"
					:style="`${isMobile?'font-size: 1.1rem;padding: 1rem;':'font-size: 1.5rem;padding: 2rem;'}`"
					style="border: 1px solid #e8e8e8;">
					<div class="df jcsb" style="font-weight: bold;">
						<span :style="`${isMobile?'width: 40%;':'width: 66%;'}`">name</span>
						<div class="df"
							:style="`${isMobile?'width: 66%;font-size: 1.1rem;':'width: 30%;font-size: 1.5rem;'}`">
							<span style="width: 50%;">Amount</span>
							<span style="margin-left: 1rem;width: 50%;"></span>
						</div>
					</div>
					<div class="df jcsb" v-for="(item,index) in list" style="margin-top: 1rem;" :key="index">
						<span :style="`${isMobile?'width: 40%;font-size: 0.8rem;':'width: 66%;font-size: 1.4rem;'}`"
							class="text_over" style="cursor: pointer;"
							@click="$router.push({name:'supplierdetail',query:{id:item.providerId}})">{{item.provider.providerName}}</span>
						<div class="df" :style="`${isMobile?'width: 60%;':'width: 30%;'}`">
							<span style="margin-right: 0.8rem;color: #FF2C2C;width: 50%;">${{item.offer_price}}</span>
							<el-button :size="isMobile?'small':null" style="background-color: #22F7D3;color: #000;"
								:style="`${isMobile?'width: 35%;font-size:0.6rem;h':'width: 50%;'}`"
								@click="visible2=true,params2.providerId=item.providerId">Inquire</el-button>
						</div>
					</div>
					<div v-show="list.length==0" class="nodata-box">
						<img src="../../assets/imgs/nodata.svg" class="nodata-img">
					</div>
				</div>
			</template>
			<template v-else>
				<el-button v-if="data.offer" style="width: 100%;margin-top: 1rem;font-size: 22px;color: #000;">Quotation
					Details:
					<span style="color: crimson;">${{data.offer.offer_price}}</span></el-button>
				<el-button v-else @click="showQoute"
					style="background-color: #22F7D3;width: 100%;margin-top: 1rem;font-size: 22px;color: #000;">Quote</el-button>
			</template>
			<el-dialog title="Quotation" :visible.sync="visible" :width="`${isMobile?'75':'35'}%`" center>
				<el-input v-model="params.offer_price" placeholder="Enter number">
					<div style="font-size: 20px;font-weight: bold;color: #000;" slot="prefix" class="df aic jcc">
						<span style="transform: translate(5px,4px);">$</span>
					</div>
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="offer"
						style="background-color: #22F7D3;width: 100%;color: #000;">Confirm</el-button>
				</span>
			</el-dialog>
			<el-dialog title="Inquiry content" :visible.sync="visible2" :width="`${isMobile?'75':'35'}%`" center>
				<el-input style="margin-bottom: 1rem;" v-model="params2.name" placeholder="*Enter Name" />
				<el-input style="margin-bottom: 1rem;" v-model="params2.contact" placeholder="*Enter Email" />
				<el-input type="textarea" :rows="4" v-model="params2.content" placeholder="*Enter content">
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="contact"
						style="background-color: #22F7D3;width: 100%;color: #000;">Send</el-button>
				</span>
			</el-dialog>
		</div>
		<Footer style="margin-top: 3rem;"></Footer>
	</div>
</template>

<script>
	import Header from '/src/components/header.vue'
	import Footer from '/src/components/footer.vue'
	export default {
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				visible: false,
				visible2: false,
				data: {},
				hideDetail: false,
				list: [],
				user: {},
				params: {
					productCustomId: null,
					offer_price: null,
					remark: ""
				},
				params2: {
					"productCustomId": null,
					"content": "",
					"providerId": null,
					"contact": "",
					name: ''
				},
				isMobile: false
			}
		},
		mounted() {
			this.isMobile = localStorage.getItem('isMobile') == 'null' ? false : true
			this.getData(this.$route.query.id)
			this.getPriceList(this.$route.query.id);
			this.params.productCustomId = this.$route.query.id;
			this.params2.productCustomId = this.$route.query.id;
		},
		methods: {
			showQoute() {
				if(this.user.provider){
					if (!this.user.provider.isPay) {
						return this.$bus.$emit('message', {
							type: 1,
							msg: 'Non-member service providers cannot quote!'
						})
					} else if (this.user.provider.status == 1) {
						this.visible = true;
					}
				} else {
						return this.$bus.$emit('message', {
							type: 1,
							msg: 'You need to become a service provider first!'
						})
					}
			},
			async getData(id) {
				let {
					data
				} = await this.$get(`/gci/product/custom/${id}/detail`)
				data.properties = JSON.parse(data.properties)
				this.data = data;
				let res = await this.$get(`/gci/product/custom/${id}/offers`)
				this.list = res.data.items;
				let res2= await this.$get('/gci/user/info')
				this.user =res2.data;
				// JSON.parse(localStorage.getItem("user"))
				this.$nextTick(() => {
					if (this.$refs.describe.offsetHeight > 64) this.hideDetail = true;
				})
			},
			async getPriceList(productCustomId) {
				let {
					data
				} = await this.$get(`/gci/product/custom/${productCustomId}​/offers`)
				this.list = data.items
			},
			async offer() {
				if (!this.params.offer_price) return this.$bus.$emit('message', {
					type: 1,
					msg: 'Number cannot be 0!'
				})
				let res = await this.$post('/gci/product/custom/offer', this.params)
				this.data.offer = {};
				this.data.offer.offer_price = this.params.offer_price;
				this.visible = false;
			},
			async contact() {
				let res = await this.$post('/gci/product/enquiry/add', this.params2)
				this.visible2 = false;
				this.$bus.$emit('message', {
					type: 2,
					msg: res.msg
				})
			},
			download() {
				const a = document.createElement('a'); // 创建一个HTML 元素
				let url = this.data.attachment;
				a.setAttribute('download', ''); //download属性
				a.setAttribute('href', url); // href链接
				a.click(); // 自执行点击事件
			}
		}
	}
</script>

<style lang="scss" scoped>
	#wrap {
		width: 400px;
		height: 500px;
		overflow: hidden;
	}

	.pic {
		width: 400px;
		height: 400px;
		border: 1px solid #e8e8e8;
		position: relative;
	}

	.pic-cover {
		position: absolute;
		top: 0;
		left: 0;
	}

	.cover {
		width: 200px;
		height: 200px;
		background-image: url(../../assets/imgs/cover.png);
		position: absolute;
		top: 0;
		left: 0;
		display: none;
		cursor: move;
	}

	.img-wrap {
		width: 80%;
		overflow: hide;
	}

	#wrap .tab {
		display: flex;
		overflow: hide;
		height: 50px;
		overflow-y: hidden;
		margin-top: 20px;
	}

	#wrap .tab .img {
		width: 50px;
		height: 50px;
		float: left;
		margin: 0 13px;
		cursor: pointer;
		border: 1px solid #e8e8e8;
		transition: border .3s;
		position: relative;
	}

	#wrap .tab .on {
		border: 2px solid #24e9e5;
	}

	.opetate {
		height: 50px;
		width: 25px;
		background: #F2F2F2;
		border-radius: 2px;
		cursor: pointer;
	}

	.show {
		width: 400px;
		height: 400px;
		position: absolute;
		top: 0;
		right: -410px;
		display: none;
		// background: url(images/1.jpg) no-repeat;
	}

	.title {
		color: #000;
		font-size: 1.5rem;
		font-weight: bold;
		// margin-top: 0.5rem;
		width: 100%;
		position: relative;

		// &:before {
		// 	content: "";
		// 	display: inline-block;
		// 	width: 0.5rem;
		// 	height: 1.5rem;
		// 	border-radius: 0.2rem;
		// 	margin-right: 0.3rem;
		// 	background-color: #24e9e5;
		// 	position: absolute;
		// 	left: -0.8rem;
		// 	top: 0.5rem;
		// }
	}

	.describe {
		font-size: 1rem;
		color: #777777;
		line-height: 2.01rem;
		margin-top: 1rem;
	}

	.attr {
		margin-top: 1rem;
	}

	.merchant {
		padding: 2rem 0;
		margin-top: 2rem;
		border: 1px solid #e8e8e8;
		border-left: none;
		border-right: none;
	}

	.tag {
		color: #000;
		margin-right: 10px;
		border: 1px solid #e8e8e8;
		padding: 2px 5px;
		border-radius: 20px;
	}

	.button {
		width: 10rem;
		height: 3rem;
		opacity: 1;
		color: #000;
		border: none;
		flex-wrap: nowrap;
		padding: 0;
		font-weight: bold;
	}
</style>